import { validate } from 'uuid';

export function validateUuid(uuid: string | string[]): boolean {
	return Array.isArray(uuid) ? uuid.every((id) => validate(id)) : validate(uuid);
}
